import hress1eLabels from 'assets/labels/hress1e'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hress1eLabels
    }
  },
  index () {
    let mockRows = []
    const mockStaappr = [ '1', '2', '3', '4' ]
    const mockStatus = {
      '1': 'ยังไม่ดำเนินการ',
      '2': 'ระหว่างดำเนินการ',
      '3': 'เสร็จสมบูรณ์',
      '4': 'เลื่อนกำหนด'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        kpino: i,
        kpiitem: faker.name.findName(),
        status: mockStaappr[i - 1],
        dtetarg: moment().format('DD/MM/YYYY'),
        target: faker.lorem.word(),
        desc_status: mockStatus[i - 1],
        v_mtrunit: faker.lorem.word(),
        mtrvalue: faker.random.number().toString().substr(0, 1),
        codempid: '',
        dteyreap: moment().format('YYYY'),
        numtime: faker.random.number().toString().substr(0, 1),
        mtrunit: '',
        coduser: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockDetail1Rows = []
    const mockDetail1Total = 5
    for (var a = 1; a <= mockDetail1Total; a++) {
      mockDetail1Rows.push({
        workno: a,
        workitem: faker.random.words(),
        actbedon: faker.random.words(),
        spsubport: faker.random.words()
      })
    }
    let mockDetail2Rows = []
    const mockDetail2Total = 5
    for (var w = 1; w <= mockDetail2Total; w++) {
      mockDetail2Rows.push({
        workno: w,
        dteapkpi: moment().format('DD/MM/YYYY'),
        actbedon: faker.random.words(),
        mtrvalue: faker.random.number().toString().substr(0, 1),
        mtrvalnet: faker.random.number().toString().substr(0, 1)
      })
    }

    return {
      table1: {
        total: mockDetail1Rows,
        rows: mockDetail1Rows
      },
      table2: {
        total: mockDetail2Rows,
        rows: mockDetail2Rows
      }
    }
  },
  dropdowns () {
    const mockStatus = {
      '1': 'ยังไม่ดำเนินการ',
      '2': 'ระหว่างดำเนินการ',
      '3': 'เสร็จสมบูรณ์',
      '4': 'เลื่อนกำหนด'
    }

    return {
      status: {
        en: mockStatus,
        th: mockStatus
      }
    }
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hress1e/mocker.js